// @flow
import type { TaxonomyName, TaxonomyNode } from '../types'

export const addProps = (props: Object = {}) => ({
  ...props,
  language: 'sv'
})

export const sortByName = (a: TaxonomyName, b: TaxonomyName): number => {
  return a.name.localeCompare(b.name, 'sv')
}

export const unique = (item: TaxonomyNode, index: number, self: Object) => {
  return self.findIndex(t => t.taxonomy_path === item.taxonomy_path) === index
}

export const filterDuplicates = (array: any) => {
  return array.filter(function(item, pos, self) {
    return self.indexOf(item) == pos
  })
}

export const deconstructJWT = (token: string) => {
  const segments = token.split('.')

  if (!segments instanceof Array || segments.length !== 3) {
    throw new Error('Invalid JWT')
  }
  return JSON.parse(decodeURIComponent(escape(window.atob(segments[1]))))
}

export const isIE11 = () => {
  return !!window.MSInputMethodContext && !!document.documentMode
}

export const testMobileDevice = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  )
}



// WEBPACK FOOTER //
// ./src/utils/helpers.js